function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 120.929,
  cy: 130.929,
  r: 99.9295,
  fill: "#40444A"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 101,
  r: 4,
  fill: "#292F35"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 79,
  r: 6,
  stroke: "#848D96",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 184,
  r: 6,
  stroke: "#4F555C",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M242.179 229.848H76.2217C73.6849 229.848 71.6309 227.791 71.6309 225.256V88.7931C71.6309 80.7479 78.1511 74.2277 86.1963 74.2277H232.204C240.248 74.2277 246.77 80.7479 246.77 88.7931V225.256C246.77 227.792 244.714 229.848 242.179 229.848Z",
  fill: "#848D96"
}), React.createElement("path", {
  opacity: 0.6,
  d: "M246.768 88.7946V225.254C246.768 227.791 244.715 229.848 242.179 229.848H228.252C230.788 229.848 232.845 227.791 232.845 225.254V88.7946C232.845 80.7465 226.323 74.2291 218.279 74.2291H232.207C240.249 74.2291 246.768 80.7465 246.768 88.7946Z",
  fill: "#1B1F24"
}), React.createElement("path", {
  d: "M246.768 88.7946V111.07H71.6289V88.7946C71.6289 80.7465 78.152 74.2291 86.1987 74.2291H232.207C240.249 74.2291 246.768 80.7465 246.768 88.7946Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  opacity: 0.2,
  d: "M246.768 88.7946V111.07H232.845V88.7946C232.845 80.7465 226.323 74.2291 218.279 74.2291H232.207C240.249 74.2291 246.768 80.7465 246.768 88.7946Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M101.127 128.036H91.1622C89.5778 128.036 88.2949 126.752 88.2949 125.169C88.2949 123.586 89.5778 122.302 91.1622 122.302H101.127C102.711 122.302 103.994 123.586 103.994 125.169C103.994 126.752 102.711 128.036 101.127 128.036Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M131.755 128.036H121.789C120.206 128.036 118.922 126.752 118.922 125.169C118.922 123.586 120.206 122.302 121.789 122.302H131.755C133.338 122.302 134.622 123.586 134.622 125.169C134.622 126.752 133.338 128.036 131.755 128.036Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M162.383 128.036H152.417C150.834 128.036 149.551 126.752 149.551 125.169C149.551 123.586 150.834 122.302 152.417 122.302H162.383C163.967 122.302 165.25 123.586 165.25 125.169C165.25 126.752 163.967 128.036 162.383 128.036Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M193.009 128.036H183.043C181.46 128.036 180.176 126.752 180.176 125.169C180.176 123.586 181.46 122.302 183.043 122.302H193.009C194.592 122.302 195.876 123.586 195.876 125.169C195.876 126.752 194.592 128.036 193.009 128.036Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M223.636 128.036H213.672C212.088 128.036 210.805 126.752 210.805 125.169C210.805 123.586 212.088 122.302 213.672 122.302H223.636C225.221 122.302 226.504 123.586 226.504 125.169C226.504 126.752 225.221 128.036 223.636 128.036Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M101.127 142.454H91.1622C89.5778 142.454 88.2949 141.17 88.2949 139.587C88.2949 138.004 89.5778 136.719 91.1622 136.719H101.127C102.711 136.719 103.994 138.004 103.994 139.587C103.994 141.17 102.711 142.454 101.127 142.454Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M131.755 142.454H121.789C120.206 142.454 118.922 141.17 118.922 139.587C118.922 138.004 120.206 136.719 121.789 136.719H131.755C133.338 136.719 134.622 138.004 134.622 139.587C134.622 141.17 133.338 142.454 131.755 142.454Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M162.383 142.454H152.417C150.834 142.454 149.551 141.17 149.551 139.587C149.551 138.004 150.834 136.719 152.417 136.719H162.383C163.967 136.719 165.25 138.004 165.25 139.587C165.25 141.17 163.967 142.454 162.383 142.454Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M193.009 142.454H183.043C181.46 142.454 180.176 141.17 180.176 139.587C180.176 138.004 181.46 136.719 183.043 136.719H193.009C194.592 136.719 195.876 138.004 195.876 139.587C195.876 141.17 194.592 142.454 193.009 142.454Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M223.636 142.454H213.672C212.088 142.454 210.805 141.17 210.805 139.587C210.805 138.004 212.088 136.719 213.672 136.719H223.636C225.221 136.719 226.504 138.004 226.504 139.587C226.504 141.17 225.221 142.454 223.636 142.454Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M144.585 213.923C142.429 213.923 140.272 213.101 138.628 211.456L123.886 196.713C120.595 193.424 120.595 188.091 123.886 184.801C127.175 181.512 132.509 181.512 135.799 184.801L144.585 193.587L178.999 159.171C182.29 155.883 187.623 155.881 190.912 159.171C194.202 162.461 194.202 167.794 190.912 171.085L150.541 211.456C148.896 213.101 146.74 213.923 144.585 213.923Z",
  fill: "#B0BAC4"
}), React.createElement("path", {
  d: "M102.906 85.836H97.5804C95.3176 85.836 93.4824 84.0022 93.4824 81.738V67.8075C93.4824 65.5447 95.3176 63.7109 97.5804 63.7109H102.906C105.169 63.7109 107.004 65.5447 107.004 67.8075V81.738C107.004 84.0022 105.169 85.836 102.906 85.836Z",
  fill: "#848D96"
}), React.createElement("path", {
  d: "M141.178 85.836H135.85C133.588 85.836 131.754 84.0022 131.754 81.738V67.8075C131.754 65.5447 133.588 63.7109 135.85 63.7109H141.178C143.44 63.7109 145.274 65.5447 145.274 67.8075V81.738C145.274 84.0022 143.44 85.836 141.178 85.836Z",
  fill: "#848D96"
}), React.createElement("path", {
  d: "M179.451 85.836H174.124C171.861 85.836 170.027 84.0022 170.027 81.738V67.8075C170.027 65.5447 171.861 63.7109 174.124 63.7109H179.451C181.714 63.7109 183.548 65.5447 183.548 67.8075V81.738C183.548 84.0022 181.712 85.836 179.451 85.836Z",
  fill: "#848D96"
}), React.createElement("path", {
  d: "M217.721 85.836H212.395C210.132 85.836 208.297 84.0022 208.297 81.738V67.8075C208.297 65.5447 210.132 63.7109 212.395 63.7109H217.721C219.983 63.7109 221.819 65.5447 221.819 67.8075V81.738C221.819 84.0022 219.983 85.836 217.721 85.836Z",
  fill: "#848D96"
}), React.createElement("path", {
  d: "M261.629 211.541C261.629 230.967 245.882 246.714 226.456 246.714C207.03 246.714 191.283 230.967 191.283 211.541C191.283 192.117 207.03 176.37 226.456 176.37C245.882 176.37 261.629 192.117 261.629 211.541Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M251.751 211.541C251.751 225.512 240.425 236.836 226.455 236.836C212.486 236.836 201.16 225.512 201.16 211.541C201.16 197.571 212.486 186.247 226.455 186.247C240.425 186.247 251.751 197.571 251.751 211.541Z",
  fill: "#1B1F24"
}), React.createElement("path", {
  d: "M226.457 196.896C224.874 196.896 223.59 195.613 223.59 194.029V190.537C223.59 188.954 224.874 187.669 226.457 187.669C228.04 187.669 229.324 188.954 229.324 190.537V194.029C229.324 195.613 228.04 196.896 226.457 196.896Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M226.457 235.414C224.874 235.414 223.59 234.13 223.59 232.547V229.055C223.59 227.471 224.874 226.188 226.457 226.188C228.04 226.188 229.324 227.471 229.324 229.055V232.547C229.324 234.13 228.04 235.414 226.457 235.414Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M247.461 214.408H243.969C242.386 214.408 241.102 213.126 241.102 211.541C241.102 209.958 242.386 208.675 243.969 208.675H247.461C249.045 208.675 250.328 209.958 250.328 211.541C250.328 213.126 249.045 214.408 247.461 214.408Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M232.777 214.408H226.457C224.874 214.408 223.59 213.126 223.59 211.541V205.734C223.59 204.15 224.874 202.867 226.457 202.867C228.04 202.867 229.324 204.151 229.324 205.734V208.675H232.776C234.36 208.675 235.643 209.958 235.643 211.541C235.643 213.126 234.36 214.408 232.777 214.408Z",
  fill: "#4F555C"
}), React.createElement("path", {
  d: "M208.943 214.408H205.451C203.867 214.408 202.584 213.126 202.584 211.541C202.584 209.958 203.867 208.675 205.451 208.675H208.943C210.526 208.675 211.811 209.958 211.811 211.541C211.811 213.126 210.526 214.408 208.943 214.408Z",
  fill: "#4F555C"
}), React.createElement("circle", {
  cx: 233,
  cy: 97,
  r: 4,
  fill: "#292F35"
}));

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 53,
  cy: 174,
  r: 4,
  fill: "#292F35"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M262 164C261.172 164 260.5 164.672 260.5 165.5V168.5H257.5C256.672 168.5 256 169.172 256 170C256 170.828 256.672 171.5 257.5 171.5H260.5V174.5C260.5 175.328 261.172 176 262 176C262.828 176 263.5 175.328 263.5 174.5V171.5H266.5C267.328 171.5 268 170.828 268 170C268 169.172 267.328 168.5 266.5 168.5H263.5V165.5C263.5 164.672 262.828 164 262 164Z",
  fill: "#848D96"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170 38C169.172 38 168.5 38.6716 168.5 39.5V42.5H165.5C164.672 42.5 164 43.1716 164 44C164 44.8284 164.672 45.5 165.5 45.5H168.5V48.5C168.5 49.3284 169.172 50 170 50C170.828 50 171.5 49.3284 171.5 48.5V45.5H174.5C175.328 45.5 176 44.8284 176 44C176 43.1716 175.328 42.5 174.5 42.5H171.5V39.5C171.5 38.6716 170.828 38 170 38Z",
  fill: "#B0BAC4"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59 203C58.1716 203 57.5 203.672 57.5 204.5V207.5H54.5C53.6716 207.5 53 208.172 53 209C53 209.828 53.6716 210.5 54.5 210.5H57.5V213.5C57.5 214.328 58.1716 215 59 215C59.8284 215 60.5 214.328 60.5 213.5V210.5H63.5C64.3284 210.5 65 209.828 65 209C65 208.172 64.3284 207.5 63.5 207.5H60.5V204.5C60.5 203.672 59.8284 203 59 203Z",
  fill: "#848D96"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 190,
  height: 190,
  fill: "white",
  transform: "translate(72 60)"
})));

var SvgAllocationsHistoryEmptyStateDark = function SvgAllocationsHistoryEmptyStateDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAllocationsHistoryEmptyStateDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "media/allocationsHistoryEmptyStateDark.0595dab2.svg";
export { ForwardRef as ReactComponent };